import React, { Fragment } from "react";
import { Link } from "gatsby";
import PostTags from "./PostTags";
import Card from "./Card";
import Img from "gatsby-image";
import ModalVideo from "react-modal-video";

class PostListing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      posts: []
    };
  }

  componentDidMount() {
    const { postEdges } = this.props;
    const posts = postEdges.map(postEdge => {
      let iconClass = "";
      switch (postEdge.node.frontmatter.category) {
        case "Article":
          iconClass = `fas fa-pencil-alt`;
          break;
        case "News":
          iconClass = `fas fa-newspaper`;
          break;
        case "Podcast":
          iconClass = `fas fa-microphone`;
          break;
        case "Tool":
          iconClass = `fas fa-download`;
          break;
        case "Video":
          iconClass = `fas fa-video`;
          break;
        case "Webinar":
          iconClass = `fas fa-headset`;
          break;
        default:
          iconClass = ``;
      }

      return {
        path: postEdge.node.fields.slug,
        externalUrl: postEdge.node.frontmatter.externalUrl,
        tags: postEdge.node.frontmatter.tags,
        image: postEdge.node.frontmatter.image,
        thumb: postEdge.node.frontmatter.thumb.childImageSharp.fluid,
        youtubeId: postEdge.node.frontmatter.youtubeId,
        preface: postEdge.node.frontmatter.preface,
        title: postEdge.node.frontmatter.title,
        author: postEdge.node.frontmatter.author,
        date: postEdge.node.fields.date,
        teaser: postEdge.node.frontmatter.teaser,
        category: postEdge.node.frontmatter.category,
        iconClass: iconClass,
        featured: postEdge.node.frontmatter.featured,
        callToAction: postEdge.node.frontmatter.callToAction
      };
    });

    this.setState({
      posts: posts
    });
  }

  render() {
    return (
      <div className="flex-container make-equal-height">
        {this.state.posts.map((post, index) => {
          const card = (
            <Card
              preface={post.preface}
              thumb={post.thumb}
              title={post.title}
              iconClass={post.iconClass}
              category={post.category}
              tags={post.tags}
              youtubeId={post.youtubeId}
              featured={post.featured}
              callToAction={post.callToAction}
              externalUrl={post.externalUrl}
            />
          );

          return (
            <Fragment key={index}>
              {post.externalUrl ? (
                <a
                  className={
                    `insight-card ` + (post.featured ? `featured` : ``)
                  }
                  href={post.externalUrl}
                  target="_blank"
                >
                  {card}
                </a>
              ) : (
                <Link className="insight-card" to={post.path}>
                  {card}
                </Link>
              )}
            </Fragment>
          );
        })}
        {/* <pre>{JSON.stringify(this.state.posts, null, 4)}</pre> */}
      </div>
    );
  }
}

export default PostListing;
